export class ScrollTop {
  constructor() {
    const backToTopButton = document.querySelector('.footer-toTopButton');

    // ボタンクリック時に実行する関数
    backToTopButton.onclick = function() {
        scrollToTop();
    };

    function scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }
}
